import * as R from 'ramda';
import styled from 'styled-components';
import { width, space } from 'styled-system';
// mui
import { useTheme } from '@mui/material';
// forms
import { renderBorderColor } from '../forms/ui';
//////////////////////////////////////////////////

const ReportWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ jc }) => jc || 'baseline'};
  & svg:hover {
    cursor: pointer;
  }
  & img {
    height: 20px;
  }
`;

const FilterDate = styled.div`
  ${width}
  ${space}

  display: flex;

  justify-content: ${({ justifyContent }) => justifyContent};

  & > div:last-child {
    margin: 0;
  }
  & .react-datepicker {
    width: max-content;
  }
  & .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list {
      height: 183px !important;
    }
  & .react-datepicker-popper {
    top: 5px !important;
    left: -50px !important;
  }
`;

const MultiSelectWrapper = styled.div`
  ${space}
  ${width}

  & > div.Select {
    & .Select-control {
      height: 30px;
      border-radius: 2px;
      border-color: ${props => renderBorderColor(props)};
    }

    &.is-focused:not(.is-open) .Select-control {
      box-shadow: 0 0 5px 0 rgba(206, 40, 40, 0.5);
      border-color: ${({ theme }) => theme.colors.linkColor};
    }
  }

  & .Select-input {
    margin: 0px;
    padding: 0px;
    height: 28px;

    & input {
      height: 28px;
      padding: 0px;
    }
  }

  & .Select-value {
    margin: 2px;
  }

  & .Select-placeholder {
    z-index: 0;
    line-height: 28px;
  }
`;

const getDefaultStyles = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { colors, palette } = useTheme();

  const optionColorsMap = {
    '#DEEBFF': colors.white,
    '#2684FF': colors.bgColor,
    transparent: 'transparent',
  };

  const input = {
    maxWidth: '120px',
    fontSize: '13px !important',
    color: palette.text.primary,
  };

  const menuList = {
    maxHeight: 310,
    background: colors.white,
  };

  const valueContainer = {
    display: 'flex',
    alignItems: 'center',
  };

  const indicatorSeparator = {
    opacity: 0,
    color: palette.text.primary,
  };

  const indicatorsContainer = {
    display: 'none',
  };

  const placeholder = active => ({
    opacity: active ? 1 : 0,
    color: palette.text.primary,
  });

  const container = {
    flex: 1,
    alignSelf: 'stretch',
    textTransform: 'none',
  };

  const multiValue = {
    width: 50,
    fontSize: 15,
    borderRadius: '16px',
    justifyContent: 'center',
    background: colors.white,
  };

  const control = {
    height: '100%',
    border: 'none',
    boxShadow: 'none',
    background: 'none',
    position: 'relative',
    color: palette.text.primary,
  };

  const option = (provided, state) => ({
    fontSize: 13,
    display: 'flex',
    padding: '5px 10px',
    alignItems: 'center',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    color: state.isSelected ? palette.text.primary : colors.linkColor,
    height: state.data.label ? `${state.data.label.length + 30}px` : 'auto',
    background: R.pathOr(null, [provided.backgroundColor], optionColorsMap),
    ':hover': { background: colors.middleGrey },
    ':active': { background: colors.tableHeaderTextColor },
  });

  const singleValue = {
    color: `${palette.text.primary} !important`,
  };

  const multiValueLabel = {
    color: palette.text.primary,
  };

  const multiValueRemove = {
    width: 14,
    padding: 0,
    height: 15,
    cursor: 'pointer',
    alignSelf: 'center',
    ':hover': {
      color: colors.white,
      borderRadius: '50%',
      background: `${palette.text.primary} !important`,
    },
  };

  const DropdownIndicator = () => {
    const { palette } = useTheme();

    return (
      <svg width='6' height='5' viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          fill={palette.text.primary || '#787878'}
          // eslint-disable-next-line max-len
          d='M0.257807 1.75844L2.41614 3.91677C2.74114 4.24177 3.26614 4.24177 3.59114 3.91677L5.74947 1.75844C6.27447 1.23344 5.89947 0.333435 5.15781 0.333435H0.84114C0.099473 0.333435 -0.267193 1.23344 0.257807 1.75844Z'
        />
      </svg>
    );
  };

  return ({
    input,
    option,
    control,
    menuList,
    container,
    multiValue,
    singleValue,
    placeholder,
    valueContainer,
    multiValueLabel,
    multiValueRemove,
    DropdownIndicator,
    indicatorSeparator,
    indicatorsContainer,
  });
};

export {
  FilterDate,
  ReportWrapper,
  getDefaultStyles,
  MultiSelectWrapper,
};
